import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskHistoryComponent } from './task-history.component';
import { FormsModule } from '@angular/forms';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarModule } from 'primeng/calendar';
import { ModalFilesModule } from 'src/app/shared/modal-files/modal-files.module';
import { WidgetModule } from 'src/app/shared/widget/widget.module';
import { TaskComentsModule } from '../task-coments/task-coments.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  declarations: [
    TaskHistoryComponent,
  ],
  imports: [
    CommonModule,
    NgbModalModule,
    TranslateModule,
    ModalFilesModule,
    WidgetModule,
    FormsModule,
    TaskComentsModule,
    CalendarModule,
    InfiniteScrollModule,
    NgbTooltipModule,
  ],
  exports: [
    TaskHistoryComponent
  ]
})
export class TaskHistoryModule { }
